import { app } from '../../../../../../../bootstrap/core';

import { createRequestBankNumbersComponent } from './bankNumbers.component';

app.component(
  createRequestBankNumbersComponent.name,
  createRequestBankNumbersComponent,
);
